import api from "../../api/api";


class DynamicFormulaService {

    // Добавление дисциплины к гибкой суммарной формуле.
    async addDisciplineFormula(ageGroupId, disciplineId, formulaId) {
        return await api().post('/dynamic/add-discipline-formula', {
            age_group_id: ageGroupId,
            discipline_id: disciplineId,
            formula_id: formulaId
        });
    }

    // Создание новой суммарной формулы.
    async createSumFormula(formulaName) {
        return await api().post('/dynamic/create-sum-formula', {
            formula_name: formulaName
        });
    }

    // Удаление дисциплины из гибкой суммарной формулы.
    async deleteDisciplineFormula(disciplineResultId) {
        return api().delete('/dynamic/delete-discipline-formula', {
            data: {
                discipline_result_id: disciplineResultId
            }
        });
    }

    // Удаление суммарной формулы.
    async deleteSumFormula(formulaId) {
        return await api().delete('/dynamic/delete-sum-formula', {
            data: {
                formula_id: formulaId
            }
        });
    }

    // Получение всех суммарных формул и их дисциплин.
    async getAllSumFormula(ageGroupId) {
        return await api().get(`/dynamic/get-all-sum-formula/${ageGroupId}`);
    }

    // Получение списка дисциплин для суммарной формулы.
    async getDisciplineForSumFormula() {
        return await api().get(`/dynamic/get-disciplines-for-sum-formula`);
    }

    // Вывод дисциплин гибкой суммарной формулы.
    async getSumFormulaDisciplines(formulaId, ageGroupId) {
        return await api().get(`/dynamic/get-sum-formula-disciplines/${formulaId}/${ageGroupId}`);
    }

    // Переименование суммарной формулы.
    async renameSumFormula(formulaId, formulaName) {
        return await api().patch('/dynamic/rename-sum-formula', {
            formula_id: formulaId,
            formula_name: formulaName
        });
    }
}

export default new DynamicFormulaService();